<template>
  <div class="document-container">
    <div class="columns">
      <div class="column">
        <!-- Match Options Header && Tabs -->
        <match-options-header ref="header" class="document"/>
        <!-- Match Options Tab Selection (Person || Address) -->
        <router-view name="matchOptionsSelection"/>
      </div>
    </div>
  </div>
</template>

<script>
import MatchOptionsHeader from '@/views/DirectMatch/MatchOptions/MatchOptionsHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';

export default {
  mixins: [
    BreadcrumbsManager,
  ],
  components: {
    MatchOptionsHeader,
  },
  created() {
    this.setBreadcrumb([
      { text: 'Home', to: { name: 'directMatch' } },
      { text: 'Match Options', to: {} },
    ]);
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(evt) {
      const { header } = this.$refs;
      const { tabs } = header.$refs;
      if (evt.key === 'Tab' && tabs.selectedIndex < 0) {
        evt.preventDefault();
        tabs.focusOption();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
